<template>
  <div>
    <vxe-grid
      auto-resize
      ref="vxeGrid"
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      class="bg-white"
      :loading="loading"
      border
    >
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.scmAttributeStatus === 'Y' ? 'light' : 'warning'"
          >{{ row.scmAttributeStatusName }}</el-tag
        >
      </template>
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="fromLoad('detail', row.scmAttributeCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              @click="fromLoad('edit', row.scmAttributeCode)"
              class="el-icon-edit tool-btn"
            ></i>
            "
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D')"
            v-show="row.scmAttributeStatus === 'Y'"
          >
            <i @click="del([row])" class="el-icon-delete tool-btn"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="600px"
    >
      <page-detail ref="form" @success="saveSuccess"></page-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">{{
          $l('INDEX.btn_cancel') || '取 消'
        }}</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
          v-show="formOption.dialogSaveBtnVisible"
          >{{ $l('INDEX.btn_save') || '保 存' }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    },
    tablePage: {
      default: null,
      type: Object
    }
  },
  components: {
    PageDetail: () => import('./components/detail')
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  data() {
    return {
      allChecked: false,
      indeterminate: false,
      selected: [],
      tableHeight: 600,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('submit')
        },
        zoom: true,
        custom: true
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
          fixed: 'left'
        },
        {
          title: this.$l('table_label_attribute_type') || '属性类型',
          field: 'scmAttributeType',
          minWidth: 150,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          title: this.$l('table_label_name_cn') || '中文名称',
          field: 'scmAttributeName',
          minWidth: 200,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title'
        },
        {
          title: this.$l('table_label_name_en') || '英文名称',
          field: 'scmAttributeNameEn',
          minWidth: 200,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title'
        },
        {
          title: this.$l('table_label_status') || '状态',
          width: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          slots: { default: 'status' }
        },
        {
          title: this.$l('table_label_attribute_desc') || '属性说明',
          field: 'scmAttributeDescription',
          width: 170,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          title: this.$l('form_label_created_by') || '创建人',
          field: 'createByName',
          width: 120,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          title: this.$l('form_label_created_date') || '创建时间',
          field: 'createDate',
          width: 170,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('form_label_modified_by') || '修改人',
          field: 'modifyByName',
          width: 120,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          title: this.$l('form_label_modified_date') || '修改时间',
          field: 'modifyDate',
          width: 170,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.table_label_operation') || '操作',
          field: 'col-opt',
          headerAlign: 'center',
          fixed: 'right',
          align: 'center',
          width: 130,
          slots: {
            default: 'opt'
          }
        }
      ],
      // 表单设置
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true
      }
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 130
    },
    // 加载表单
    fromLoad(ref, val = '') {
      const opt = {
        add: this.$l('tips_add') || '新增',
        edit: this.$l('tips_edit') || '编辑',
        detail: this.$l('tips_view') || '详情'
      }
      // 设置标题
      this.formOption.title = opt[ref]
      // 控制保存按钮显隐
      if (ref === 'detail') {
        this.formOption.dialogSaveBtnVisible = false
      } else {
        this.formOption.dialogSaveBtnVisible = true
      }
      // 显示表单
      this.formOption.dialogFormVisible = true
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.form.fromLoad(ref, val)
      }, 0)
    },
    delRows() {
      let selection = this.selected
      if (!selection || selection.length < 1) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据',
          type: 'warning'
        })
        return
      }
      this.del(selection)
    },
    del(array) {
      this.$confirm(this.$l('INDEX.tips_question_delete') || '是否要删除？', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api
            .scmDictionaryUpdateStatusApi({ scmDictionaryList: array })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_delete_ok') || '删除成功',
                type: 'success'
              })
              this.$emit('submit')
            })
        })
        .catch(() => {})
    },
    save() {
      this.$refs.form.save()
    },
    saveSuccess() {
      this.cancel()
      this.$emit('submit')
    },
    cancel() {
      this.formOption.dialogFormVisible = false
    },
    onRowSelected(items) {
      this.selected = items
      if (items.length === 0) {
        this.indeterminate = false
        this.allChecked = false
      } else if (items.length === this.tableData.length) {
        this.indeterminate = false
        this.allChecked = true
      } else {
        this.indeterminate = true
        this.allChecked = false
      }
    },
    // 选中单行
    selectRow(index) {
      let isRowSelected = this.$refs.table.isRowSelected(index)
      if (isRowSelected) {
        this.$refs.table.unselectRow(index)
      } else {
        this.$refs.table.selectRow(index)
      }
    },
    // 表格全选/取消全选
    selectAllRows() {
      if (!this.allChecked) {
        this.$refs.table.selectAllRows()
      } else {
        this.$refs.table.clearSelected()
      }
    }
  }
}
</script>
